<template>
  <div></div>
</template>

<script>
import ssoLoginApi from '@/api/sso-login'
import { userUtils } from '@/utils/auth'
export default {
  created () {
    localStorage.removeItem('ssoToken')
    let userInfo = userUtils.getClientInfo()
    if (userInfo) {
      ssoLoginApi.authLogout().then(res => {
        if (res.data.resultCode === '0') {
          this.$notify({
            type: 'success',
            message: '登出成功！'
          })
          if (this.$route.query.type === '02') {
            this.$router.push({ name: 'ssoLogoutLoading' })
          } else {
            localStorage.removeItem('userInfo')
            document.location = process.env.VUE_APP_EXTRA_SITE + '/#/tab/home'
          }
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
          document.location = process.env.VUE_APP_EXTRA_SITE + '/#/tab/home'
        }
      })
    } else {
      this.$router.push({ name: 'ssoLogoutLoading' })
    }
  }
}
</script>

<style>

</style>
